import React, { useEffect, useRef } from "react"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { FormattedMessage, useIntl } from "gatsby-plugin-intl"

import useWindowSize from "utils/useWindowSize"
import Layout from "../layout/Layout"

import Squares from "components/Squares/Squares"
import InformationSquare from "components/InformationSquare/InformationSquare"
import Logo from "components/Logo/Logo"
import Information from "components/Information/Information"
import PicturesCarousel from "components/PicturesCarousel/PicturesCarousel"


import bgTractor from "./../../static/onepager.jpg"

import pdf from "./../../static/onepager.pdf"

import {
  View,
  SecondView,
  IconBlock,
  TitleDec,
  LastInfo,
  TitleLine,
  TextLine,
  AboutImg,
  LinkToContact,
  AboutIcon,
  IconWrapper,
  ThirdContent,
  Wrapper,
  FirstView,
  ThirdView,
  EditedInformation,
  SVGContainer,
  EditedHomeSVG,
  EditedEclipse,
  EditedButton,
  InformationContainer,
  SquaresContainer,
  InformationSquaresContainer,
  InformationSquareImage,
  LastView,
  AboutContainer,
  AboutTitle,
  EditedKredobankLogo,
  LogoContainer,
  InfoText,
  AboutText,
} from "components/home.style.js"
import { Link } from "gatsby"
import { headerContent } from "../utils/intlHelper"

gsap.registerPlugin(ScrollTrigger)
gsap.config({
  nullTargetWarn: false,
})

const Home = () => {
  const size = useWindowSize()
  const intl = useIntl()

  const informationContent = [
    {
      text: intl.formatMessage({ id: "home.secondView.description.0.text" }),
    },
    // {
    //   text: intl.formatMessage({ id: "home.secondView.description.1.text" }),
    // },
    {
      text: intl.formatMessage({ id: "home.secondView.description.2.text" }),
    }
    // {
    //   text: intl.formatMessage({ id: "home.secondView.description.3.text" }),
    // },
    // {
    //   text: intl.formatMessage({ id: "home.secondView.description.4.text" }),
    // }
    
   
  ];

  const iconContent = [
    {
      text:intl.formatMessage({ id: "home.secondView.why.0.text" }),
      icons:"data:image/png;base64,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",

    },
    {
      text:intl.formatMessage({ id: "home.secondView.why.1.text" }),
      icons:"data:image/png;base64,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",

    },
    {
      text:intl.formatMessage({ id: "home.secondView.why.2.text" }),
      icons:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABGCAYAAACaGVmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR6SURBVHgB7ZxdUtswEMdXTkqfSh1OYG6QnoDkCGmgM30qnAB6gpAbJCcIfepMQwo9QdITFE5Qn6DxM1Os7sok8YeM7dgCi+o3E4gV20h/S6vVagOAwWAwVAeDOvHVdmDHOhXv7/wxfPTcxDkz+xh/HuDrJ/S9C1BAPUQJxBgA8ONQqQv95f76aGp3wGITfOdsTuEnKoR5XlEmtg029gyfn+GRnTwBG+2jOA02AA4dyR2iwlXE84iSKcYaL+NzUNFbnlaU/GIUofLe8jSi5BWD8wUw1n7kHA+H0Q3WuhO7rgeH3jVUhAUqITGu9gawy36jIOeQ1lgSw+ddbFgXf48lZ3hYPgSL70MDBQiG1QaLnUKFqOkpRXoGhyEceYt12RVe66OI4esYLOD9srs+ntrnKMQgci8SNXyfElQrSn6b4eI5J6mNyGp0HuFKwCQVQn8APuFHHSiODVliAA6DrNli294i7p8CxyHXYNfQ+zOEDDai0FN+y65S/IGyuLnECLNNb8lDjmG2MbRv2FyBICsD+a6wL9GEEcQNaiMkUs/zUoxyFp2sEwJRaD3BoA3VsZktjrxz0YCiyBpND42G9wqZcBXQDH4lxibNDGMxDlc02EGOnhQ0hCrb98pXlu7jA023dqgeVNeFeE/CTe2xxLZcYz1uxTuLoX0Mr5eyseCb3U5c5PPP6DOciadMFcgWpHzPkLFtb2EoItWDXpy7UBBL3CDOkTcSf/h7a45KP2Zr1IgRZhvbEheuIHKP9rL169nFWEH35vxLpCxPb2lITEJO2EOcYp7/En4B9zCGV6BOiDh/cXjH60h+C0MHcIVPwSnhNG7gYklwiuupTujCEVh+0LN6kiAWbCXKi8KFO/RbYhE+tQvC+oMRP0gMs/9dFBwrzIkXGVEkNKWl/SUrM6XVGgbovQuHLpVm6icVxSZqBz3sjICJGT4SjCgSjCgSjCgSjCgSjCgSjCgSmqA70d0HB4pCYYhZiz8cuXDPe/qKQukbr9mk4mA7hSgmeooi8llEEMyBqsEAvn42hfandkT8xwFF6NdTdkV030mUc44RfPgBRbFwa4dFN+j1EiXYFTyOlboYK+5haPEGtiFYIEZE0Wv43Auj6kTKOG7HbCtICnqJwhO7mG6VyTor9BKFJXrJLShAt9knnsH0FhSgW09xI8c0nGiKrhjdDO0iVmLDrrX1TmAaeonyAWcZypOLgLuCs72J8HIrQj/njRIH4ymjlL6+g/7LrEU2p/R2rn6i0C7D1B5KclKIrJy7XOgZT6FMB8p6UIS+QSYShnLpEjamJJyN9Q4yBe59F9dEDs5MbYnHmySZlUU5vUH+i4X26HA50j/yRgR5JvTKdvmDVNTO+ph8nyCNbY2J0UowokgwokgwokgwokiQi6Jg5akTFjr6bqJUwcpTJ4Kcnkt7Hs01FbiJ+MVLINgrctbHki9PNR9OlKw88UKubm+lzgQ2hVaeChdYurExtIpXnrUlnvcPsu8Q0uLKx6FEiysGSgLDNULZP5EwGAyGFf8AH8PLGSHI+YgAAAAASUVORK5CYII=",

    }
  ]


  const squaresContent = [
    {
      title: intl.formatMessage({ id: "home.thirdView.content.0.title" }),
      text: intl.formatMessage({ id: "home.thirdView.content.0.text" }),
      id: 1,
    },
    {
      title: intl.formatMessage({ id: "home.thirdView.content.1.title" }),
      text: intl.formatMessage({ id: "home.thirdView.content.1.text" }),
      id: 2,
    },
  ]

  const ref = useRef(null)

  useEffect(() => {
    if (size.width > 750) {
      gsap.fromTo(
        ref.current,
        { y: "+=100", opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 2,
          stagger: 0.2,
          ease: "easeOut",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 90%",
            end: "top 70%",
            scrub: 1,
          },
        }
      )
    } else {
      gsap.set(ref.current, { opacity: 1 })
    }
  })

  return (
    <Layout>
      <Wrapper>
        <FirstView>
          <EditedInformation>
            <div>
              <Logo>
                <FormattedMessage id="home.firstView.logo" />
              </Logo>
              <InfoText>
                <FormattedMessage id="home.firstView.firstInformation" />
              </InfoText>
              
            </div>
          </EditedInformation>
          
        </FirstView>
        <SecondView id="about">

                {/* // title={intl.formatMessage({ id: "home.secondView.title" })}
                // content={informationContent} */}
                <AboutImg>
                  <img src={bgTractor} style={{
                    // height: '100%',
                    objectFit: 'contain'
                  }} />
                </AboutImg>
                <AboutContainer>
                  <AboutTitle> <FormattedMessage id="home.secondView.title" /> </AboutTitle>

                {
                  informationContent.map((item)=>
                      (
                      <>
                        <AboutText>{item.text}</AboutText>
                      </>
                    )
                  )
                }
                <AboutText > <a style={{color:'black'}} href={pdf} target="_blank" > <FormattedMessage id="home.secondView.allInfo" />  </a>    </AboutText>
                <AboutIcon>
                  {
                    iconContent.map(({text, icons},id) =>(
                      <>
                      <IconBlock key={id}>
                      <IconWrapper>
                        <img src={icons}/>
                      </IconWrapper>
                      <AboutText style={{
                            lineHeight:'26px',
                            fontSize: '16px',
                            textAlign:'center',
                            color: 'rgb(78, 78, 78)'
                      }} >{text}</AboutText>
  
                    </IconBlock></>
                      
                    ))
                  }
                 
                 
                </AboutIcon>


                </AboutContainer>
         
        </SecondView>

        <ThirdView  id="fertilizers">
          <ThirdContent>
          <Link to="/services/fertilizers"> 
          <p  style={{
              paddingTop: '22px',
              fontSize: '38px',
              color: 'white'
            }}>
            <FormattedMessage id="servicesOptions.name" />
            </p>
            <TitleDec >
             <FormattedMessage id="servicesOptions.desc" />
            </TitleDec>
            <p style={{
              paddingTop: '30px',
              fontSize: '22px',
              color: 'white'
            }}>
              <FormattedMessage id="servicesOptions.all" /> 
            </p>
            </Link>
          </ThirdContent>
          
        </ThirdView>


            


        
        <LastView>
          <PicturesCarousel />

          {/*   */}
          <LastInfo >
            {
              size.width >=600 ? (<TitleLine> <FormattedMessage id="lines.title" /> </TitleLine>): null
            }
            
            <TextLine> <FormattedMessage id="lines.description" /> </TextLine>
            <TextLine> <FormattedMessage id="lines.qa" /> </TextLine>
            <a href="#contact"><LinkToContact><FormattedMessage id="lines.link" /></LinkToContact></a>
            </LastInfo>
        </LastView>
      </Wrapper>
    </Layout>
  )
}

export default Home
